import styled from 'styled-components';

const PostStyle = styled.div`
  .postContainer {
    display: flex;
    flex-direction: column;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    padding: 30px 130px;
    margin: 10px 10px 13px 10px;
    height: auto;
    max-width: 100%;
    align-items: center;
    font-style: normal;
    font-stretch: normal;
    background-color: #ffffff;
    border-radius: 4px;
  }

  a {
    color: #00B4B3;
  }

  img {
    width: 100%;
  }

  iframe {
    width: 100%;
  }

  .title {
    width: 100%;
    // height: 78px;
    font-size: 30px;
    font-weight: bold;
    line-height: 1.3;
    letter-spacing: normal;
    color: #000000;
    margin-bottom: 6px;
  }

  .description {
    width: 100%;
    min-height: 29px;
    font-size: 25px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #818181;
    margin-top: 7px;
    margin-bottom: 6px;
    padding: 0px 130px

  }

  .dateAndAuthor {
    height: 16px;
    width: 100%;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #6f6d6d;
    margin: 0 0 13px 0;
  }

  .shareButtons {
    display: flex;
    color: #000000;
    width: 100%;
    align-items: center;
    font-size: 14px;
    margin: 0;
    flex-wrap: wrap;
  }

  .articleTypeContainer {
    width: 100%;
    margin-top: 9px;
  }



  .postContent {
    font-family: Helvetica Neue;
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    line-height: 1.94;
    letter-spacing: normal;
    color: #000000;
  }

  .track-button {
    max-width: 100px;
    background-color: #00B4B3;
    padding: 5px 10px;
    // font-family: "arial", "sans-serif";
    border-radius: 4px;

    a {
      text-decoration: none;
      font-weight: 300;
      padding: 30px;
      color: #ffffff;
    }

    width: 205px;
    height: 36px;
    background-color: #00b4b3;

    img {
        fill: #000000
    }
  }

  .trackButtonContainer {
    width: 175px;
    height: 36px;
    margin: 0;

  }

  .bitTrackArtistContainer {
    display: flex;
    align-items: center;
  }

  .artistName {
    display: inline-block;
    font-size: 1.5em;
    font-weight: bold;
    padding-right: 20px;
    margin: 0;
  }

  .trackButton {
    height: 23px;
    width: 70px;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    background-color: #00B4B3;
    padding: 5px 10px;
    font-family: "arial", "sans-serif";
    border-radius: 2px;

    text-decoration: none;
    font-weight: 300;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
  }

  .track_table {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding: 5px;
    box-sizing: border-box;
  }

  .artistTrackButton {
      height: 23px;
      width: 70px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background-color: #00B4B3;
      padding: 5px 10px;
      font-family: "arial", "sans-serif";
      border-radius: 2px;
      text-decoration: none;
      font-weight: 300;
      color: #ffffff;
      font-size: 14px;
      text-align: center;

  }

  .trackTable_artistName {
    font-weight: bold;
  };

  .buttonTrackTable {
    width: 33%;
    height: 23px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #00B4B3;
    padding: 5px 10px;
    font-family: "arial", "sans-serif";
    border-radius: 2px;
    text-decoration: none;
    font-weight: 300;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
  }

  .trackTable {
    display: flex;
    align-items: center;
  }

  .containerForPreview {
    width: 100%;
    // border: 1px solid red;
  }

  @media (max-width: 700px){
    .postContainer {
      padding: 14px;
    }

    .title {
      height: auto;
    }
    .description {
      height: auto;
    }

    .shareButtons {
      flex-wrap: wrap
      .item {
        margin-bottom: 9px
      }
    }
  }
`

export default PostStyle;
